"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function syncBrandingSettings(settings) {
  return (0, _utils.actionCreator)(_types.SYNC_BRANDING_SETTINGS, settings);
}
var _default = exports["default"] = syncBrandingSettings;